export default __webpack_public_path__ + "static/media/circle-grey.df976453.svg";